import React, {Component} from "react";
import { Circle } from 'rc-progress';
import styled from "styled-components";
import {ProgressObject} from "../../reducers";
import errorIcon from "../../../img/exclamation-error.svg";
import successIcon from "../../../img/Check.svg";
import "../../../styles/ProgressIndicator.css"

export interface ProgressIndicatorProps {
  className?: string;
  size: string;
  progressInfo: ProgressObject;
  icon: string;
  inProgressMessage?: JSX.Element | undefined;
  progressCompleteMessage?: JSX.Element | undefined;
  progressFailureMessage?: JSX.Element | undefined;
  children: React.ReactNode;
  onSuccess?: () => JSX.Element;
  onFailure?: () => JSX.Element;
  hidden?: boolean;
}

export interface ProgressIndicatorState {
  wait: boolean,
  interval: number
}

const STROKE_COLOR: any = {
  "IN_PROGRESS": "#007FAD",
  "SUCCESS": "#0A870A",
  "FAILURE": "#CC313D",
  "DEFAULT": "#007FAD"
};

const SIZE_MAP: any = {
  "large": {
    "ringHeight": 220,
    "ringWidth": 220,
    "iconHeight": 100,
    "iconWidth": 120
  },
  "small": {
    "ringHeight": 140,
    "ringWidth": 140,
    "iconHeight": 50,
    "iconWidth": 50
  }
};

const CLASS_NAME_FOR_STATUS: any = {
  "SUCCESS_small": "pi-custom-green-check-sm"
};

export default class ProgressIndicator extends Component<ProgressIndicatorProps, ProgressIndicatorState> {
  iconHeight: number;
  iconWidth: number;
  ringHeight: number;
  ringWidth: number;

  ProgressRingContainer: any;
  ProgressRingIcon: any;

  constructor(props: any) {
    super(props);

    this.iconHeight = SIZE_MAP[props.size].iconHeight;
    this.iconWidth  = SIZE_MAP[props.size].iconWidth;
    this.ringHeight = SIZE_MAP[props.size].ringHeight;
    this.ringWidth  = SIZE_MAP[props.size].ringWidth;

    this.ProgressRingContainer = styled.div`
      position: relative;
      display: block;
      margin: auto;
      margin-top: 56px;
      width: ${this.ringWidth}px;
      height: ${this.ringHeight}px;
  `;

    this.setDelayedState = this.setDelayedState.bind(this);

    this.state = {
      wait: false,
      interval: 0
    };
  }

  componentWillUpdate(nextProps: ProgressIndicatorProps, nextState: ProgressIndicatorState) {
    if (this.state.wait && !nextState.wait) {
      this.triggerSuccessAnimation();
    }
  }

  getProgressIndicator(status: string, message: JSX.Element | undefined, icon: string, color?: string) {
    return (
      <div id={"progressIndicator"} className={this.props.className ? this.props.className : ""}>
        <div>
        <this.ProgressRingContainer>
          <Circle percent={this.props.progressInfo.progress}
                  strokeWidth={4}
                  trailWidth={4}
                  strokeColor={color || STROKE_COLOR['DEFAULT']}
                  trailColor="#ECECEC"
          />
          <img className={CLASS_NAME_FOR_STATUS[`${status}_${this.props.size}`]
          || `pi-default-icon-${this.props.size}`}
                                 src={icon}
                                 width={this.iconWidth}
                                 height={this.iconHeight}/>
        </this.ProgressRingContainer>
        <div key={status} className={"progress-indicator-messages"}>{message}</div>
        </div>
      </div>
    )
  };

  setDelayedState() {
    this.setState({
      wait: true,
      interval: window.setTimeout(() => {
        this.setState({
          wait: false
        })
      }, 3000)
    });
  }

  renderOnSuccess(props: ProgressIndicatorProps){
    if (!props.onSuccess) {
      return this.getProgressIndicator(
        props.progressInfo.status,
        props.progressCompleteMessage,
        successIcon,
        STROKE_COLOR[props.progressInfo.status]
      );
    } else {
      if (this.state.interval === 0) {
        this.setDelayedState();
        return this.getProgressIndicator(props.progressInfo.status, props.progressCompleteMessage, props.icon);
      } else {
        if (!this.state.wait) {
          clearInterval(this.state.interval);
          return props.onSuccess();
        }
        return this.getProgressIndicator(props.progressInfo.status, props.progressCompleteMessage, props.icon);
      }
    }
  }

  triggerSuccessAnimation() {
  }


  getRenderedContent(props: ProgressIndicatorProps) {
    if (!this.props.hidden) {
      switch (props.progressInfo.status) {
        case 'IN_PROGRESS':
          return this.getProgressIndicator(
            props.progressInfo.status,
            this.props.inProgressMessage,
            this.props.icon
          );
        case 'SUCCESS':
          return this.renderOnSuccess(props);
        case 'FAILURE':
          return this.getProgressIndicator(
            props.progressInfo.status,
            this.props.progressFailureMessage,
            errorIcon,
            STROKE_COLOR[props.progressInfo.status],
          );
        default:
          return this.props.children
      }
    }
    return this.props.children
  }

  render() {
    return this.getRenderedContent(this.props)
  }

}
